import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from 'app/application-http-client';
import { Observable } from 'rxjs';

import { Setting, SettingType } from './models';

@Injectable()
export class SettingsService {
  private apiUrl = '/settings/settings/';
  private apiRouteOneUrl = '/push/routeone';
  private apiDealerTrackUrl = '/push/dealertrack';

  public getSettingTypes(): Observable<SettingType[]> {
    return this.http.get(`${this.apiUrl}/keyoptions`);
  }

  public getSettings(configurationId?: number): Observable<Setting[]> {
    return this.http.get(`${this.apiUrl}/GetSettingsByConfiguration/${configurationId}`);
  }

  public addSetting(setting: Setting): Observable<Setting> {
    return this.http.post(this.apiUrl, setting);
  }

  public updateSetting(setting: Setting): Observable<Setting> {
    return this.http.put(`${this.apiUrl}/${setting.id}`, setting);
  }

  public deleteSetting(setting: Setting): Observable<Setting[]> {
    return this.http.delete(`${this.apiUrl}/${setting.id}`);
  }

  public compareSettingTypes(a: SettingType, b: SettingType): number {
    if (a.displayAs < b.displayAs) {
      return -1;
    }
    if (a.displayAs > b.displayAs) {
      return 1;
    }
    return 0;
  }

  
public GetDealerTrackIdFromEvent(eventId: number): Observable<string> {
  const params = ApplicationHttpClient.toHttpParams({
    eventId: eventId,
  });

  return this.http.get(`${this.apiDealerTrackUrl}/GetDealerTrackIdFromEvent`, {
    params: params,
    errorNotification: true,
  });
  
}


public GetRouteOneIdFromEvent(eventId: number): Observable<string> {
  const params = ApplicationHttpClient.toHttpParams({
    eventId: eventId,
  });

  return this.http.get(`${this.apiRouteOneUrl}/GetRouteOneIdFromEvent`, {
    params: params,
    errorNotification: true,
  });
}  

  constructor(private http: ApplicationHttpClient) {}
}
